export default __webpack_public_path__ + "static/media/1.ab254a88.jpg";